module.exports = __webpack_public_path__ + "img/Compliance Automation.e9b600f9.svg";